<template>
  <el-dialog
      title="Добавление параметра фильтра"
      :visible.sync="$store.getters.popularItemCreateDialog"
      width="30%"
      :before-close="handleClose"      
  >
    <el-form @submit.prevent="savePresetItem" label-width="180px" label-position="left">
      <el-form-item label="Выберите фильтр">
        <el-select
        v-model="form.optionId"
        filterable
        no-data-text="Нет данных"
        placeholder="Выбарите фильтр"
        @change="onOption">
          <el-option
            v-for="item in options"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="getTypeOption === typeItem.checkbox.value" label="Выбарите значения">
        <el-select
          v-model="form.values"
          filterable
          multiple
          no-data-text="Нет данных"
          placeholder="Выбарите значения"
          v-loading="isLoadinValues"
        >
          <el-option
            v-for="(item, index) in values"
            :key="index"
            :label="item.value"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-else-if="getTypeOption === typeItem.range.value" label="Выбарите значения">
        <el-row
        type="flex"
        v-loading="isLoadinValues"
        >
        <el-col>
          <el-input type="number" v-model="form.min"></el-input>
        </el-col>
        <el-col>
          <el-input type="number" v-model="form.max"></el-input>
        </el-col>
      </el-row>
      </el-form-item>
    </el-form> 
    <span slot="footer" class="dialog-footer">
    <el-button @click="$store.commit('popularItemCreateDialog',false)">Отмена</el-button>
    <el-button type="primary" :disabled="disableButton" @click="savePresetItem">Добавить</el-button>
  </span>
  </el-dialog>
</template>

<script>
import axios from "axios";
import typeItem from "@/composable/type/filter-item.type";
import prestTypesConfig from '@/composable/config/preset-type.config.js';

export default {
  name: "CreatePresetItemDialog",
  props: ['sectionId'],
  data: function (){
    return{
      prestTypesConfig,
      typeItem,
      form:{
        title: '',
        min: 0,
        max: 0,
        optionId: '',
        values: [],
      },
      options: [],
      values: [],
      isLoadinValues: false,
    }
  },
  computed:{
    disableButton(){
      if(!this.form.optionId) return true
      if (this.getTypeOption === this.typeItem.checkbox.value) {
        if (this.form.values.length <= 0) return true
        return false
      }
      if (this.getTypeOption === this.typeItem.range.value) {
        if (this.form.min <= 0) return true
        if (this.form.max <= 0) return true
        if (this.form.min >= this.form.max) return true
        return false
      }
      return true;
    },
    getTypeOption() {
      if (this.form.optionId) {
        return this.options.find((e) => e.id === this.form.optionId).type || this.typeItem.checkbox.value
      }
      return this.typeItem.checkbox.value
    },
  },
  mounted() {
    this.getPresetOptions()
  },
  methods:{
    handleClose() {
      this.$store.commit('popularItemCreateDialog',false);
    },
    savePresetItem(){
      const option = this.getEmitValues()
      if (option) {
        this.$emit('changePresetValue', option)
      }
      this.handleClose()
    },
    addItemElement(){
      this.form.values.push('')
    },
    deleteItemElement(index) {
      if (this.form.values[index] !== undefined) {
        this.form.values.splice(index, 1)
      }
    },
    setValues(v) {
      this.values = v ? v : []
      if (!v || v.length <= 0) {
        this.form.values = []
      }
    },
    getPresetOptions() {
      axios.get(`compilation/options?catalog_section_id=${this.sectionId}`)
      .then((response) => {
        this.options = response.data        
      })
      .catch(() => this.options = [])
    },
    // eslint-disable-next-line no-unused-vars
    getValues(idOption) {
      this.isLoadinValues = true
      axios.get(`compilation/options/${idOption}`)
      .then((response) => {
        this.setValues(response.data);
      })
      .catch(() => this.setValues())
      .finally(() => this.isLoadinValues = false)
    },
    getEmitValues() {
      const option = this.options.find((e) => e.id === this.form.optionId)
      if (option) {
        if (option.type === this.typeItem.checkbox.value) {
          option['values'] = [...this.form.values];
        }
        if (option.type === this.typeItem.range.value) {
          option['range'] = { min: this.form.min, max: this.form.max };
        }
        return option
      }
      return undefined
    },
    onOption() {
      if (this.form?.optionId) {
        this.setValues()
        this.getValues(this.form.optionId)
      }
    }
  }
}
</script>

<style scoped>
.el-row {
  margin-bottom: 12px;
}
</style>